import {
  FetchUsageRequest,
  FetchUsageResponse,
} from "@shared/services/usage-explorer/fetchUsage.ts";
import {
  fillPartitionItems,
  replaceData,
} from "@shared/services/tour/mockedApis/usageExplorer/usage-explorer-mock-tools.ts";
import { UnitFamily } from "@shared/utils/myJFrogUtils.ts";
import { NUMBER_OF_DAYS_IN_RANGE } from "@shared/services/tour/mockedApis/usageExplorer/usage-explorer-mock-const.ts";

import json from "../../json/usageExplorer/usageExplorerGetUsageMlCredits.json";

export default async (data?: object) => {
  const response = JSON.parse(JSON.stringify(json)) as FetchUsageResponse;
  response.nonce = (data as FetchUsageRequest).nonce;
  fillPartitionItems(response, NUMBER_OF_DAYS_IN_RANGE);
  replaceData({
    response,
    dataPerDay: [
      35.588, 21.196, 30.694, 7.941, 11.0, 15.776, 33.196, 33.037, 25.519,
      21.048, 35.56, 30.355, 27.734, 9.815, 24.754, 14.174, 28.78, 21.776,
      26.458, 16.756, 27.486, 27.906, 28.79, 11.685, 17.531, 9.942, 12.833,
      24.781, 36.426, 20.463,
    ].reverse(),
    repartitionPercentage: [48, 19, 12, 8, 5, 3, 2, 2, 1],
    unitFamily: UnitFamily.SIMPLE_NUMBER,
    computationMode: "overtime",
  });
  return response;
};
